import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Spinner, Badge } from "react-bootstrap";
import axiosInstance from "../../API/axiosInstance";
import VendorCard from "../../ui_components/vendor_card/vendor_card";
import DynamicBreadcrumbs from "../dynamic_breadcumb/dynamic_breadcrumb";
import './wishlist.css'
import DownloadAppUI from "../../ui_components/download_app/download_app";
import SiteFooter from "../../ui_components/site_footer/site_footer";

const Wishlist = () => {
    const [wishlist, setWishlist] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [token, setToken] = useState(() => {
        const storedToken = localStorage.getItem('token')
        if (storedToken) {
            return storedToken
        }
        else {
            return null
        }
    });
    const [user, setUser] = useState(() => {
        const storedUser = localStorage.getItem('currentUser')
        if (storedUser) {
            return JSON.parse(storedUser)
        }
        else {
            return null
        }
    });

    const navigate = useNavigate();
    const loadWishlist = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get(`/wishlist/${user.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (res.status == 200) {
                setWishlist(res.data);
            }
        } catch (err) {
            console.error("Error loading wishlist", err);
        }
    };

    useEffect(() => {

        loadWishlist();
    }, []);

    useEffect(() => {
        const loadVendors = async () => {
            try {
                const res = await axiosInstance.post(
                    "/vendor/byIds",
                    wishlist,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log(res.data);
                setVendorList(res.data);
            } catch (err) {
                console.error("Error loading vendors", err);
            } finally {
                setLoading(false);
            }
        };

        loadVendors()
    }, [wishlist])


    const removeFromWishlist = async (v) => {
        const response = await axiosInstance.delete(`/wishlist/${user.id}/remove?vendorId=${v.id}`, {
            headers: { "Authorization": `Bearer ${token}` }
        })

        if (response.status == 200) {
            alert("Vendor removed from Wishlist")
            loadWishlist()
        }
        else {
            alert("something went wrong!")
        }
    }

    return (
        <div className="container py-4">
            <DynamicBreadcrumbs />
            <h3 className="m-0 wishlist-title">My Wishlist</h3>
            {loading ? (
                <div className="d-flex justify-content-center h-auto">
                    <Spinner animation="border" />
                </div>
            ) : vendorList.length === 0 ? (
                <p className="text-center text-muted">No vendors in your wishlist yet.</p>
            ) : (
                <div className="row h-auto">
                    {vendorList.map((vendor) => (
                        <div className="col-md-6 col-lg-4 mb-4" key={vendor.id}>
                            <VendorCard
                                vendor={vendor}
                                isInWishlist={true}
                                onWishlistToggle={(v) => removeFromWishlist(v)}
                            />
                        </div>
                    ))}
                </div>
            )}

            <section className="my-5">
                {/* Download the app */}
                <div id='download-app-container' className='m-0'>
                    <DownloadAppUI />
                </div>

                {/* Site Footer */}
                <div>
                    <SiteFooter />
                </div>
            </section>
        </div>
    );
};

export default Wishlist;
